import React, { useEffect, useState } from "react";
import { TenantService } from "../../Services";
import { Button, Card, Col, Input, Row, Table } from "antd";
import { useNavigate } from "react-router-dom";
import Controls from "./Controls";

const RTMAdminDashboard = () => {
	const navigate = useNavigate();

	const [allTenants, setAllTenants] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [searchText, setSearchText] = useState("");

	useEffect(() => {
		const fetchTenants = async () => {
			try {
				const response = await TenantService.getAllTenants();
				setAllTenants(response.data);
			} catch (err) {
				setError("Failed to fetch tenants");
			} finally {
				setLoading(false);
			}
		};

		fetchTenants();
	}, []);

	if (error) {
		return <div>{error}</div>;
	}

	// Filter tenants by search text (case-insensitive)
	const filteredTenants = allTenants.filter(t => t.tenant.toLowerCase().includes(searchText.toLowerCase()));

	return (
		<Row gutter={[12, 12]}>
			<Col span={24}>
				<Row justify="center" align="middle">
					<h1>RTM Admin Dashboard</h1>
				</Row>
			</Col>

			<Col span={24}>
				<Controls />
			</Col>

			<Col span={24}>
				<Card title="Tenants">
					<Input
						placeholder="Search tenants"
						value={searchText}
						onChange={e => setSearchText(e.target.value)}
						style={{ width: 250, marginBottom: 16 }}
						allowClear
					/>

					<Table
						rowKey="tenant"
						loading={loading}
						dataSource={filteredTenants}
						columns={[
							{
								title: "Tenant Name",
								dataIndex: "tenant",
								key: "tenant"
							},
							{
								title: "Action",
								key: "action",
								render: (_, record) => (
									<Button
										type="primary"
										onClick={() => navigate(`/dashboard/rtmadmin/tenant/${record.tenant}`)}
									>
										Edit
									</Button>
								)
							}
						]}
					/>
				</Card>
			</Col>
		</Row>
	);
};

export default RTMAdminDashboard;
